"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatText = formatText;
var _react = _interopRequireDefault(require("react"));
var _HideMask = _interopRequireDefault(require("../../molecules/HideMask"));
var _lurker = _interopRequireDefault(require("../../../helpers/lurker"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function maskIsValid(mask, text) {
  return mask && typeof mask.start === 'number' && typeof mask.end === 'number' && typeof mask.textLink === 'string' && typeof mask.textContent === 'string' && mask.start < mask.end && mask.end <= text.length;
}
function formatTextUnsafe(idMessage, text, masks, moreFormating) {
  if (text && masks && masks.forEach) {
    var newText = [];
    var currentStart = 0;
    masks.forEach(function (mask) {
      if (!maskIsValid(mask, text)) {
        throw new Error("Invalid mask: ".concat(JSON.stringify(mask)));
      }
      if (mask.start < currentStart) {
        throw new Error("Overlaps position: currentStart=".concat(currentStart, ", mask.start=").concat(mask.start));
      }
      if (currentStart < mask.start) {
        newText.push(moreFormating(text.substring(currentStart, mask.start)));
      }
      var masked = /*#__PURE__*/(0, _jsxRuntime.jsx)(_HideMask["default"], {
        textLink: mask.textLink,
        lurkerObjectDetail: mask.lurkerObjectDetail,
        idMessage: idMessage,
        children: moreFormating(mask.textContent)
      }, "".concat(mask.start, "_").concat(idMessage));
      newText.push(masked);
      currentStart = mask.end;
    });
    if (currentStart < text.length) {
      newText.push(moreFormating(text.substring(currentStart, text.length)));
    }
    return newText;
  }
  return moreFormating(text);
}
function formatText(idMessage, text, masks) {
  var moreFormating = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (t) {
    return t;
  };
  try {
    return formatTextUnsafe(idMessage, text, masks, moreFormating);
  } catch (e) {
    var error = "".concat(e);
    _lurker["default"].formatTextError(idMessage, error);
    return text;
  }
}